import { NgModule } from '@angular/core';
import { ExpressCheckoutProvidersComponent } from './express-checkout-providers/express-checkout-providers.component';
import { ExpressCheckoutComponent } from './express-checkout.component';

@NgModule({
  declarations: [],
  imports: [ExpressCheckoutProvidersComponent, ExpressCheckoutComponent],
  exports: [ExpressCheckoutProvidersComponent, ExpressCheckoutComponent],
})
export class ExpressCheckoutModule {}
